import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import Select from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import AdminSidebar from "../../layouts/AdminSidebar";
import { handleNumericInput } from "../../util/utils";
import { authCall } from "../../../services";
import AppConstants from "../../../appConstants";
import ImageUploads from "../../util/ImageUploads";

const PRODUCT_CATEGORY = [
  { value: "caps", label: "Caps" },
  { value: "t_shirt", label: "T-Shirt" },
  { value: "sweatshirt", label: "Sweatshirt" },
  { value: "hoodie", label: "Hoodie" },
  { value: "towel", label: "Towel" },
  { value: "accessories", label: "Accessories" },
];

const PRODUCT_SIZE = [
  { value: "S", label: "Small" },
  { value: "M", label: "Medium" },
  { value: "L", label: "Large" },
  { value: "XL", label: "Extra Large" },
  { value: "XXL", label: "Double Extra Large" },
];

const PRODUCT_COLOR = [
  { value: "white", label: "White" },
  { value: "black", label: "Black" },
  { value: "gray", label: "Gray" },
  { value: "blue", label: "Blue" },
  { value: "green", label: "Green" },
  { value: "pink", label: "Pink" },
];

const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#bababa",
    border: "2px solid #fff",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#007BFF"
      : state.isFocused
      ? "#e0e0e0"
      : "#fff",
    color: state.isSelected ? "#fff" : "#000",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#000",
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#fff",
    zIndex: 9999,
  }),
  menuList: (provided, state) => ({
    ...provided,
    backgroundColor: "#fff",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#383636",
    // fontWeight: 600,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#383636",
  }),
};

let nextId = 20031;

function ProductAdd() {
  const validator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const { current } = useSelector((state) => state.user);
  const { details } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [productImage, setProductImage] = useState(
    details?.product_image || ""
  );
  const [isProductImageChange, setIsProductImageChange] = useState(false);

  const [values, setValues] = useState({
    productId: details?.id || "",
    userId: current?.id,
    title: details?.title || "",
    subTitle: details?.sub_title || "",
    productCategory: details?.category
      ? { label: details?.category, value: details?.category }
      : "",
    productPrice: details?.price || "",
    descriptions: details?.descriptions || "",
  });

  const [variation, setVariation] = useState([
    {
      id: nextId++,
      productSize: "",
      color: "",
      productQuantitiy: "",
      productImage: "",
      isProductImageUploaded: false,
    },
  ]);

  const handleChangeValue = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleChangeState = (name, selected) => {
    setValues({ ...values, [name]: selected });
  };

  const getProductImage = (id) => (img) => {
    setVariation(
      variation.map((field) =>
        field.id === id
          ? { ...field, productImage: img, isProductImageUploaded: true }
          : field
      )
    );
  };

  const handleInputChange = (id, event, name) => {
    const fieldName = name ? name : event.target.name;
    const fieldValue = name ? event : event.target.value;
    const variations = variation.map((variant) => {
      if (variant.id === id) {
        return { ...variant, [fieldName]: fieldValue };
      }
      return variant;
    });
    setVariation(variations);
  };

  const addVariation = () => {
    setVariation([
      ...variation,
      {
        id: nextId++,
        productSize: "",
        color: "",
        productQuantitiy: "",
        productImage: "",
        isProductImageUploaded: false,
      },
    ]);
  };

  const removeVariation = (id) => {
    const newVariation = variation.filter((variant) => variant.id !== id);
    setVariation(newVariation);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();
    if (validator.current.allValid()) {
      setLoading(true);

      values.productCategory = values?.productCategory?.label
        ? values?.productCategory?.label
        : "";
      values.variations = variation;

      const res = await authCall("createProduct", values);
      if (res?.type === "success") {
        toast.success(res.message);
        setLoading(false);
        navigate(AppConstants.routes.admin.listProduct);
      } else {
        setLoading(false);
      }
    } else {
      validator.current.showMessages();
      forceUpdate(1);
      window.scrollTo(0, 0);
    }
  };

  return (
    <>
      <div className="add-machine-page py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-sm-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-sm-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">
                  {details?.id ? "Update" : "Add"} Product
                </div>
                <div className="details-wrapper pb-lg-4">
                  <form
                    onSubmit={handleSubmit}
                    className="custom-field-wrapper"
                  >
                    <div className="info-cover mb-2">
                      <div className="main-heading2 mb-2">Product Details:</div>
                      <div className="row mb-2">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <label htmlFor="title" className="fs-md-18">
                            Title:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="title"
                            name="title"
                            autoComplete="off"
                            value={values.title}
                            onChange={(e) => handleChangeValue(e)}
                          />
                          {validator.current.message(
                            "title",
                            values.title,
                            "required"
                          )}
                        </div>

                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <label htmlFor="subTitle" className="fs-md-18">
                            Sub Title:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="subTitle"
                            name="subTitle"
                            autoComplete="off"
                            value={values.subTitle}
                            onChange={(e) => handleChangeValue(e)}
                          />
                          {validator.current.message(
                            "sub title",
                            values.subTitle,
                            "required"
                          )}
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <label htmlFor="descriptions" className="fs-md-18">
                            Descriptions:
                          </label>
                          <textarea
                            id="overview"
                            rows="5"
                            className="form-control"
                            autoComplete="off"
                            name="descriptions"
                            value={values.descriptions}
                            onChange={(e) => handleChangeValue(e)}
                          ></textarea>
                          {validator.current.message(
                            "descriptions",
                            values.descriptions,
                            "required"
                          )}
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <label htmlFor="productCategory" className="fs-md-18">
                            Product Category:
                          </label>
                          <Select
                            styles={customStyles}
                            className="text-body"
                            placeholder="Select Category"
                            name="productCategory"
                            value={values.productCategory}
                            onChange={(e) =>
                              handleChangeState("productCategory", e)
                            }
                            options={PRODUCT_CATEGORY}
                          />
                          {validator.current.message(
                            "product category",
                            values.productCategory,
                            "required"
                          )}
                        </div>

                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                          <label htmlFor="productPrice" className="fs-md-18">
                            Price:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="productPrice"
                            name="productPrice"
                            autoComplete="off"
                            value={values.productPrice}
                            onChange={(e) => handleChangeValue(e)}
                          />
                          {validator.current.message(
                            "productPrice",
                            values.productPrice,
                            "required"
                          )}
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                          <label
                            htmlFor="productDiscountPrice"
                            className="fs-md-18"
                          >
                            Discounted Price:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="productDiscountPrice"
                            name="productDiscountPrice"
                            autoComplete="off"
                            value={values.productDiscountPrice}
                            onChange={(e) => handleChangeValue(e)}
                          />
                        </div>
                      </div>

                      {variation.map((el, index) => (
                        <div key={index}>
                          <div className="row mb-2">
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                              <label htmlFor="productSize" className="fs-md-18">
                                Product Size:
                              </label>
                              <Select
                                styles={customStyles}
                                className="text-body"
                                placeholder="Select Size"
                                name="productSize"
                                value={PRODUCT_SIZE.find(option => option.value === el.productSize) || null}
                                onChange={(event) =>
                                  handleInputChange(el.id, event.value, "productSize")
                                }
                                options={PRODUCT_SIZE}
                              />
                            </div>

                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                              <label htmlFor="color" className="fs-md-18">
                                Color:
                              </label>
                              <Select
                                styles={customStyles}
                                className="text-body"
                                placeholder="Select Color"
                                name="color"
                                value={PRODUCT_COLOR.find(option => option.value === el.color) || null}
                                onChange={(event) =>
                                  handleInputChange(el.id, event.value, "color")
                                }
                                options={PRODUCT_COLOR}
                              />
                            </div>
                          </div>

                          <div className="row mb-2">
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                              <label
                                htmlFor="productQuantitiy"
                                className="fs-md-18 mt-1"
                              >
                                Product Quantity:
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="productQuantitiy"
                                name="productQuantitiy"
                                autoComplete="off"
                                value={el.productQuantitiy}
                                onChange={(e) => {
                                  const inputValue = handleNumericInput(
                                    e.target.value
                                  );
                                  if (
                                    inputValue !== null &&
                                    inputValue.length < 8
                                  ) {
                                    handleInputChange(el.id, e);
                                  }
                                }}
                              />
                              {validator.current.message(
                                "product quantitiy",
                                variation[index].productQuantitiy,
                                "required"
                              )}
                            </div>

                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                              <label className="fs-md-18 mt-1">
                                Product Image:
                              </label>
                              <ImageUploads
                                getImage={getProductImage(el.id)}
                                uploadedImage={el?.productImage || productImage}
                                aspectRation={1.45 / 1}
                                croppedSize={{
                                  width: 323,
                                  height: 223,
                                  imageSmoothingQuality: "high",
                                }}
                              />
                              {validator.current.message(
                                "product image",
                                variation[index].productImage,
                                "required"
                              )}
                            </div>
                          </div>
                          {variation.length > 1 && (
                            <div className="text-red text-end">
                              <span
                                className="text-red cursor-pointer"
                                aria-hidden="true"
                                onClick={() => removeVariation(el.id)}
                              >
                                Remove
                              </span>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    {!details?.id && (
                      <div className="fw-medium text-end">
                        <span
                          className="add-another glyphicon glyphicon-plus"
                          aria-hidden="true"
                          onClick={addVariation}
                        >
                          Add Another Variation
                        </span>
                      </div>
                    )}

                    <div className="btn-wrapper text-center mt-4 mb-2 pt-2">
                      <button
                        type="submit"
                        className="btn btn-custom"
                        disabled={loading || false}
                      >
                        {loading
                          ? "Loading..."
                          : details?.id
                          ? "Update"
                          : "Submit"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductAdd;
